import {
  minimumWalletTopUp,
  numberFormat,
  THEME_PRIMARY,
  ui,
  walletAmountStep,
} from '../constants';

export function resolveAccentColor(color: string): string {
  if (color === 'primary') return THEME_PRIMARY;
  return color;
}

export function formatToman(value: number): string {
  return `${numberFormat.format(value)} ${ui.common.toman}`;
}

export function formatRial(value: number): string {
  return `${numberFormat.format(value * 10)} ${ui.common.rial}`;
}

export function normalizeDigits(value: string | number): string {
  return String(value)
    .replace(/[۰-۹]/g, (digit) => String('۰۱۲۳۴۵۶۷۸۹'.indexOf(digit)))
    .replace(/[٠-٩]/g, (digit) => String('٠١٢٣٤٥٦٧٨٩'.indexOf(digit)));
}

export function parseTomanInput(value: string | number): number {
  const numericValue = normalizeDigits(value).replace(/[^\d]/g, '');
  return numericValue ? Number(numericValue) : 0;
}

export function roundWalletAmountToStep(value: number): number {
  return Math.round(value / walletAmountStep) * walletAmountStep;
}

export function normalizeWalletAmount(value: string | number): number {
  const parsed = parseTomanInput(value);
  if (!Number.isFinite(parsed) || parsed <= 0) return minimumWalletTopUp;
  return Math.max(minimumWalletTopUp, roundWalletAmountToStep(parsed));
}

export function isValidWalletAmount(value: number): boolean {
  return (
    Number.isFinite(value) &&
    value >= minimumWalletTopUp &&
    value % walletAmountStep === 0
  );
}

export function getWalletAmountError(value: number): string | null {
  if (!Number.isFinite(value) || value <= 0) return null;
  if (value < minimumWalletTopUp) {
    return `حداقل مبلغ شارژ ${formatToman(minimumWalletTopUp)} است.`;
  }
  if (value % walletAmountStep !== 0) {
    return 'چهار رقم آخر مبلغ باید صفر باشد (مضرب ۱۰٬۰۰۰ تومان).';
  }
  return null;
}

export function formatAmountInput(value: string | number): string {
  const parsed = parseTomanInput(value);
  return parsed ? numberFormat.format(parsed) : '';
}

export function fillTemplate(
  template: string,
  values: Record<string, string | number>,
): string {
  return Object.entries(values).reduce(
    (result, [key, value]) =>
      result.split(`{${key}}`).join(String(value)),
    template,
  );
}

export { smoothScrollToElement } from './smoothScroll';
export {
  consumeCheckoutSuccessReload,
  reloadAfterCheckoutSuccess,
} from './checkoutSuccessReload';

export async function uploadOfflineReceipt(file: File): Promise<unknown> {
  const formData = new FormData();
  formData.append('receipt', file);

  const response = await fetch('/api/offline-payment-receipts', {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    throw new Error(ui.messages.receiptUploadFailed);
  }

  return response.json();
}
